import {queryString} from 'utilities/url';
import {removeNode} from '../utilities/dom';

/**
 * A simple Promise based JSONP implementation to avoid using jQuery.
 *
 * Specify the URL, but do not include the callback name,
 * this is handled within this implementation.
 *
 * @param url - string
 * @param options - object {
 *   timeout: number // number of milliseconds to wait before timing out the request
 *   data: object // JSON object which should be sent in the request URL
 *   params: object // JSON object representation of query params to include in the request URL
 * }
 * @returns {Promise}
 */
export default function jsonp(url, options = {}) {
  function noop() {
    /* noop */
  }
  const callbackName = `callback_${new Date().getTime()}`;
  const timeout = options.timeout || 10000;

  return new Promise((resolve, reject) => {
    try {
      const timeoutToken = setTimeout(() => {
        window[callbackName] = noop;
        reject(new Error(`Request timeout after ${timeout}ms`));
      }, timeout);

      const scriptEl = document.createElement('script');
      scriptEl.type = 'text/javascript';
      scriptEl.async = true;
      scriptEl.src = getSrc(url, callbackName, options);

      window[callbackName] = data => {
        clearTimeout(timeoutToken);
        window[callbackName] = noop;
        if (scriptEl) {
          removeNode(scriptEl);
        }
        resolve(data);
      };

      document.getElementsByTagName('head')[0].appendChild(scriptEl);
    } catch (error) {
      reject(error);
    }
  });
}

function getSrc(url, callbackName, options) {
  const queryParams = options.params ? encodeJsonURI(options.params) : null;
  const queryData = options.data ? encodeJsonURI(options.data) : null;
  let src = `${url}?callback=${callbackName}`;
  src += queryData ? `&${queryData}` : '';
  src += queryParams ? `&${queryParams}` : '';

  return src;
}

export function encodeJsonURI(data = {}) {
  return queryString.stringify(data);
}
